import { useState } from 'react';
import './App.css';

function App() {
  const [city, setCity] = useState('');
  const [weather, setWeather] = useState(null);
  const [error, setError] = useState('');

  const API_KEY = '6c0457356e20988ad143a77afd139f17';

  function getWeatherBackground(weatherMain) {
  switch(weatherMain) {
    case 'Clear': return 'sunny';
    case 'Rain':
    case 'Drizzle': return 'rainy';
    case 'Clouds': return 'cloudy';
    case 'Thunderstorm': return 'stormy';
    case 'Snow': return 'snowy';
    default: return 'default';
  }
}

function getWeatherEmoji(weatherMain) {
  switch(weatherMain) {
    case 'Clear': return '☀️';
    case 'Rain':
    case 'Drizzle': return '🌧️';
    case 'Clouds': return '⛅';
    case 'Thunderstorm': return '⛈️';
    case 'Snow': return '❄️';
    default: return '🌤️';
  }
}

function getRainDrops() {
  return Array.from({ length: 20 }, (_, i) => (
    <div
      key={i}
      className="raindrop"
      style={{
        left: `${Math.random() * 100}%`,
        animationDuration: `${Math.random() * 1 + 0.5}s`,
        animationDelay: `${Math.random() * 2}s`,
        opacity: Math.random() * 0.7 + 0.3,
      }}
    />
  ));
}



  async function getWeather() {
    if (city === '') {
      setError('Please enter a city!');
      return;
    }
    try {
      const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${API_KEY}&units=metric`);
      const data = await response.json();
      if (data.cod === '404') {
        setError('City not found!');
        setWeather(null);
      } else {
        setWeather(data);
        setError('');
      }
    } catch (err) {
      setError('Something went wrong!');
    }
  }

  return (
    <div className={`app ${weather ? getWeatherBackground(weather.weather[0].main) : ''}`}>
      
      {/* Always visible moving clouds */}
{[...Array(3)].map((_, i) => (
  <div
    key={i}
    style={{
      position: 'fixed',
      top: `${15 + i * 15}%`,
      left: '-10%',
      fontSize: `${2 + i * 0.5}rem`,
      animation: `floatCloud ${15 + i * 5}s linear infinite`,
      animationDelay: `${i * 4}s`,
      opacity: 0.4,
      zIndex: 0,
      pointerEvents: 'none'
    }}
  >
    ☁️
  </div>
))}


      {/* Rain effect */}
      {weather && weather.weather[0].main === 'Rain' && (
        <div className="rain-container">
          {getRainDrops()}
        </div>
      )}

      {/* Drizzle effect */}
      {weather && weather.weather[0].main === 'Drizzle' && (
        <div className="rain-container">
          {getRainDrops()}
        </div>
      )}

      {/* Thunder effect */}
      {weather && weather.weather[0].main === 'Thunderstorm' && (
        <div className="lightning-container">
          <div className="lightning"></div>
        </div>
      )}

      {/* Sun effect */}
      {weather && weather.weather[0].main === 'Clear' && (
        <div className="sun-container">
          <span className="sun">🌞</span>
        </div>
      )}

      {/* Snow effect */}
      {weather && weather.weather[0].main === 'Snow' && (
        <div className="snow-container">
          {[...Array(15)].map((_, i) => (
            <div
              key={i}
              className="snowflake"
              style={{
                left: `${Math.random() * 100}%`,
                animationDuration: `${Math.random() * 3 + 4}s`,
                animationDelay: `${Math.random() * 3}s`,
              }}
            >
              ❄️
            </div>
          ))}
        </div>
      )}

      {/* Main content */}
      <div className="content">
        <h1>🌿 Weather App</h1>
        <p className="tagline">Discover the weather anywhere in the world</p>
        
        <div className="search">
          <input
            type="text"
            placeholder="Enter city name..."
            value={city}
            onChange={(e) => setCity(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && getWeather()}
          />
          <button onClick={getWeather}>Search</button>
        </div>

        {error && <p className="error">{error}</p>}

        {weather && (
          <div className="weather-card">
            <div className="weather-emoji">
              {getWeatherEmoji(weather.weather[0].main)}
            </div>
            <h2>{weather.name}, {weather.sys.country}</h2>
            <p className="temp">{Math.round(weather.main.temp)}°C</p>
            <p className="description">{weather.weather[0].description}</p>
            <div className="details">
              <div>
                <p>{weather.main.humidity}%</p>
                <p>Humidity</p>
              </div>
              <div>
                <p>{weather.wind.speed} m/s</p>
                <p>Wind Speed</p>
              </div>
              <div>
                <p>{Math.round(weather.main.feels_like)}°C</p>
                <p>Feels Like</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

  export default App;